












































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue,Prop,Watch } from "vue-property-decorator";
import Exhibition from '../components/exhibition.vue'
import { getQueryVariable,getCommonConfig, getCountryList, Country } from "@/services/api";
import { countryDisplayName } from '@/i18n/countryLabel';
import { flowConfigLabel } from '@/i18n/flowConfigLabel';
import { FormTargetingVO, PopSettingsVO, TFormSaveDetailRequest } from "@/model/FormWheel";
import { DISABLE_CUSTOM_STEP_TPLID, isOnlyNewUserTemplate } from "@/utils/experiment";
import { TriggerEventType } from "@/constant/triggerEventType";
import InfoPopover from '../components/InfoPopover.vue'
import OptimizationHint from "@/views/wheelOfFortune/pop/optimizer/components/OptimizationHint.vue";
import { evaluateDelay, evaluateScrollPixel } from "@/views/wheelOfFortune/pop/optimizer/strategies";
import { reportFormOptimizerEvent } from "@/views/wheelOfFortune/pop/optimizer/tracking";
import { guardFormOptimizerApply, RUNNING_AB_OPTIMIZER_TIP } from "@/views/wheelOfFortune/pop/optimizer/applyGuard";
import {
  buildTargetingExamples,
  previewTargetingUrl,
  TargetingPreviewResult,
} from '../utils/targetingPreview'

// 展示间隔单位与上限映射：小时=168（7天，客户需求文正3601），分钟/秒=60（保持线上现状）
type FrequencyUnit = 'h' | 'm' | 's';
const UNIT_SECONDS: Record<FrequencyUnit, number> = { h: 3600, m: 60, s: 1 };
const UNIT_MAX: Record<FrequencyUnit, number> = { h: 168, m: 60, s: 60 };
const HOUR_IN_SECONDS = UNIT_SECONDS.h; // 3600

@Component({
  components: {
    'yc-exhibition': Exhibition,
    'info-popover': InfoPopover,
    OptimizationHint
  },
})
export default  class DispalyRules extends Vue  {
  countryDisplayName = countryDisplayName;
  flowConfigLabel = flowConfigLabel;
  @Prop(String)
  id?:string;

  @Prop(Object)
  rulesData!:any

  @Prop(Number)
  triggerEventType!:any

  @Prop(Object)
  targetingData!: FormTargetingVO

  @Prop(String)
  activeTag?:string;

  @Prop(Object)
  formData!: TFormSaveDetailRequest<PopSettingsVO>;

  @Prop({ type: Boolean, default: false })
  optimizerReadOnly!: boolean;

  rules =  this.rulesData
  delayRecommendationDismissed = false
  scrollRecommendationDismissed = false
  delayImpressionReported = false
  scrollImpressionReported = false
  delayRecommendationTriggered = false
  scrollRecommendationTriggered = false
  optimizerReadOnlyTip = RUNNING_AB_OPTIMIZER_TIP

  get delayRecommendation() {
    return evaluateDelay(this.rules);
  }

  get scrollRecommendation() {
    return evaluateScrollPixel(this.rules);
  }

  get showDelayRecommendation() {
    return this.delayRecommendationTriggered
      && !!this.delayRecommendation
      && !this.delayRecommendationDismissed;
  }

  get showScrollRecommendation() {
    return this.scrollRecommendationTriggered
      && !!this.scrollRecommendation
      && !this.scrollRecommendationDismissed;
  }

  handleDelayFieldExit() {
    this.delayRecommendationTriggered = true;
    this.$nextTick(() => this.reportRuleImpression('delay'));
  }

  handleDelayVisibleChange(visible: boolean) {
    if (!visible) this.handleDelayFieldExit();
  }

  handleScrollPixelFieldExit() {
    this.scrollRecommendationTriggered = true;
    this.$nextTick(() => this.reportRuleImpression('scroll'));
  }

  reportRuleImpression(kind: 'delay' | 'scroll') {
    const recommendation = kind === 'delay' ? this.delayRecommendation : this.scrollRecommendation;
    const alreadyReported = kind === 'delay' ? this.delayImpressionReported : this.scrollImpressionReported;
    if (!recommendation || alreadyReported) return;
    if (kind === 'delay') this.delayImpressionReported = true;
    else this.scrollImpressionReported = true;
    reportFormOptimizerEvent('form_optimizer_recommendation_impression', recommendation.strategyId, recommendation.evidenceVersion);
  }

  applyDelayRecommendation() {
    const recommendation = this.delayRecommendation;
    if (!recommendation) return;
    if (!guardFormOptimizerApply(this.optimizerReadOnly, message => this.$message.warning(message))) return;
    this.$set(this.rules, 'loadingCountDown', 5);
    this.delayRecommendationDismissed = true;
    this.changeRulesData();
    reportFormOptimizerEvent('form_optimizer_recommendation_applied', recommendation.strategyId, recommendation.evidenceVersion, {
      changed_field_keys: ['rules.loadingCountDown'],
    });
  }

  applyScrollRecommendation() {
    const recommendation = this.scrollRecommendation;
    if (!recommendation) return;
    if (!guardFormOptimizerApply(this.optimizerReadOnly, message => this.$message.warning(message))) return;
    this.$set(this.rules, 'loadingPageSlidePixel', 400);
    this.scrollRecommendationDismissed = true;
    this.changeRulesData();
    reportFormOptimizerEvent('form_optimizer_recommendation_applied', recommendation.strategyId, recommendation.evidenceVersion, {
      changed_field_keys: ['rules.loadingPageSlidePixel'],
    });
  }

  dismissDelayRecommendation() {
    const recommendation = this.delayRecommendation;
    if (!recommendation) return;
    this.delayRecommendationDismissed = true;
    reportFormOptimizerEvent('form_optimizer_recommendation_dismissed', recommendation.strategyId, recommendation.evidenceVersion);
  }

  dismissScrollRecommendation() {
    const recommendation = this.scrollRecommendation;
    if (!recommendation) return;
    this.scrollRecommendationDismissed = true;
    reportFormOptimizerEvent('form_optimizer_recommendation_dismissed', recommendation.strategyId, recommendation.evidenceVersion);
  }


  blankCloseArray = [30, 621, 907, 1333, 1334, 1379, 1738]

  // 触发事件类型枚举，用于模板中类型判断
  TriggerEventType = TriggerEventType

  // 不支持多语言的弹窗类型（嵌入式表单、自定义触发表单）
  nonMultiLanguageTypes = [TriggerEventType.EMBEDDED_FORM, TriggerEventType.CUSTOM_TRIGGER]

  // 不支持展示频次设置的弹窗类型（到货提醒、嵌入式表单、自定义触发表单）
  nonFrequencyTypes = [TriggerEventType.BACK_IN_STOCK, TriggerEventType.EMBEDDED_FORM, TriggerEventType.CUSTOM_TRIGGER]

  targeting = this.targetingData
  companyId = JSON.parse(localStorage.getItem('companyInfo') || '{}')?.id;

  urls = true
  excludeUrls = false

  // triggerCode = `<div class="cartx-popup-trigger cartx-popup-btn" data-id="${this.id || '发布后可见'}">Notify Me When Available</div>`;
  triggerFactor = ''
  // type=1（退出意图）触发条件保持 master 现状：readyToLeave / readyToLeaveBate 单选互斥
  exitIntentTriggerFactor = ''

  measureValue1:number =1
  measureValue2:number =1

  loadingCountDownOptions:number[] = []
  pageSlideOptions:number[] = [40, 50, 60, 70, 80, 90, 100]
  get pageSlideUnit() {
    return [{
      name: this.$tx('form.rules.percent', '百分比'),
      value: 'Percentage'
    }, {
      name: this.$tx('form.rules.pixel', '像素'),
      value: 'Pixel'
    }];
  }

  completeMatchingUrls = true
  completeMatchingExcludeUrl = true


  targetUserOptions: any[] = [
      {
          "show": "等于",
          "en": "EQUAL",
          "associate": 0
      },
      {
          "show": "不等于",
          "en": "NOTEQUAL",
          "associate": 0
      },
      {
          "show": "大于",
          "en": "GT",
          "associate": 0
      },
      {
          "show": "大于等于",
          "en": "GTE",
          "associate": 0
      },
      {
          "show": "小于",
          "en": "LT",
          "associate": 0
      },
      {
          "show": "小于等于",
          "en": "LTE",
          "associate": 0
      },
      {
          "show": "区间",
          "en": "BETTEN",
          "associate": 0
      },
      {
          "show": "有值",
          "en": "HAS",
          "associate": 0
      },
      {
          "show": "没值",
          "en": "HASNOT",
          "associate": 0
      }
  ]
  displayFrequencyValue: FrequencyUnit = 'h'

  prevFrequencyUnit: FrequencyUnit = 'h'  // 单位切换时记录旧单位，用于保留显示数字、按新单位重算秒数

  get displayFrequencyOptions() {
    return [
      {label: this.$tx('form.rules.unitHour', '小时'), value:"h"},
      {label: this.$tx('form.rules.unitMinute', '分钟'), value:"m"},
      {label: this.$tx('form.rules.unitSecond', '秒'), value:"s"},
    ];
  }

  urlsArr = []
  excludeUrlsArr = []

  showPageCheckout = false;

  targetingPreviewVisible = false;
  targetingPreviewInputUrl = '';
  targetingPreviewResult: TargetingPreviewResult | null = null;
  // 当前站点域名：默认可编辑，默认值为店铺集成域名，可改为客户外显域名
  targetingPreviewHostnameInput = '';

  countryList: Country[] = [{
    countryAbbreviation: 'CN',
    country: 'China',
    countryName: '中国'
  }];

  get displayFrequencyMax() {
    // 展示间隔上限：小时单位放宽到 168（7天，客户需求文正3601）；分钟/秒保持线上现状 60。
    // per-unit 的 :max 仅负责输入框「视觉钳制」（分钟/秒框输入超过 60 会被钳回 60）；
    // 真正的秒值钳制在 displayFrequency setter 内完成。
    // 注意：在「秒」单位下输入大数（如 168）再切到「小时」时，失焦会先被秒的 :max=60 钳成 60，
    // 切单位后得到 60h 而非 168h——这是符合 TC005/TC10步骤B 的预期行为（秒框上限 60 是线上现状）。
    // 要保存 168h 必须先切到「小时」单位再输入 168（TC10 主路径）。
    return UNIT_MAX[this.displayFrequencyValue];
  }

  // 展示间隔：以 rules.displayFrequency（秒）为单一真值源
  // UI 数字 = 秒 / 单位因子；setter 在 el-input-number 提交/失焦触发 v-model 时按单位钳制并写回秒值。
  // el-input-number 的 handleInput 只更新内部 userInput，v-model 在 blur/change 才外发；
  // 鼠标点保存前会先 blur 触发 setter，故能正常写回（程序化保存需注意此前置）。
  get displayFrequency(): number {
    const seconds = (this.rules && this.rules.displayFrequency) || 0;
    return seconds / UNIT_SECONDS[this.displayFrequencyValue];
  }

  set displayFrequency(v: number) {
    if (!this.rules) return;
    // el-input-number 清空会发 undefined；Number.isFinite 拦截 undefined/null/NaN/Infinity，避免写入 NaN
    if (!Number.isFinite(v)) return;
    const unit = this.displayFrequencyValue;
    // 钳制到 [1, max]：min=1 与 el-input-number :min=1 一致
    const val = Math.min(UNIT_MAX[unit], Math.max(1, v));
    // Math.round 取整保证 Long 秒值契约（避免 62s→1.0333m→62.00000001 浮点漂移）；
    // $set 兼容 displayFrequency 字段初始不存在的情况（Vue 2 新增属性需 $set 才响应式）
    this.$set(this.rules, 'displayFrequency', Math.round(val * UNIT_SECONDS[unit]));
  }

  onDisplayFrequencyChange(value: number | undefined): void {
    // 用 @change 而非 v-model/@input：el-input-number 的 value watcher 是 immediate，
    // 挂载时会无条件 $emit('input', 钳制后的值)，若用 v-model 会在挂载时触发 setter 把
    // displayFrequency=0 钳成 1、或把非整除秒值（62s→1.0333m）回写成浮点。
    // @change 只在用户操作（输入失焦/步进按钮）时触发，挂载静默钳制不污染 rules。
    if (value === undefined || value === null || !Number.isFinite(value)) return;
    this.displayFrequency = value;
  }

  get isAbtest() {
    return getQueryVariable('abtest') === 'true';
  }

  get isEditAbTest() {
    return getQueryVariable('abtest') === 'true' && getQueryVariable('edit') === 'true';
  }

  get enablePopSetting() {
    const templateId = String(getQueryVariable('templateid') || this.formData?.templateId || '');
    return this.formData.triggerEventType === 0 &&
      !['19', '20', '40', '41'].includes(templateId);
  }

  get enableOnlyNewUserCustomStep() {
    const templateId = String(getQueryVariable('templateid') || this.formData?.templateId || '');
    return isOnlyNewUserTemplate(templateId);
  }

  get enableCustomStep() {
    if ([3, 5, 6].includes(this.triggerEventType as number)) {
      return false;
    }
    const templateId = String(getQueryVariable('templateid') || this.formData?.templateId || '');
    return !DISABLE_CUSTOM_STEP_TPLID.includes(templateId);
  }

  get targetScript() {
    return this.id ? `<div id="cartx-form-${this.id}"></div>` : '保存后查看嵌入代码'
  }

  get customTargetScript() {
    return this.id ? `window.cartsee = window.cartsee || [];\n window.cartsee.push(['openForm', '${this.id}']);` : '保存后查看嵌入代码'
  }

  get targetingPreviewHostname() {
    const companyInfo = JSON.parse(localStorage.getItem('companyInfo') || '{}');
    return companyInfo?.shop || companyInfo?.site || window.location.hostname;
  }

  get targetingPreviewHost() {
    return this.targetingPreviewHostnameInput || this.targetingPreviewHostname;
  }

  get targetingPreviewExamples() {
    return buildTargetingExamples(this.targeting as any, this.targetingPreviewHost);
  }

  async getMask (){
    try {
      const result = await getCommonConfig('formClickBlankCloseStart');
      this.blankCloseArray = JSON.parse(result?.data?.data)
    } catch (e) {
      console.error('getCommonConfig formClickBlankCloseStart error', e);
    }
  }

  created() {
    this.loadingCountDownOptionsFun()
    this.displayFrequencyInit()
    this.triggerRules()
    this.initExitIntentTriggerFactor()
    this.getMask()
    this.getCountryList();
  }

  initExitIntentTriggerFactor() {
    if (this.rules?.readyToLeaveBate) {
      this.exitIntentTriggerFactor = 'readyToLeaveBate'
    } else if (this.rules?.readyToLeave) {
      this.exitIntentTriggerFactor = 'readyToLeave'
    } else {
      this.exitIntentTriggerFactor = ''
    }
  }

  changeExitIntentRulesData(val: string){
    this.rules.readyToLeave = false
    this.rules.readyToLeaveBate = false
    this.rules[val] = true
    this.$emit('changeRulesData', this.rules)
  }

  triggerRules(){
    if(this.rules?.loadingCountDownShow){
      this.triggerFactor = 'loadingCountDownShow'
    }else if(this.rules?.readyToLeave){
      this.triggerFactor = 'readyToLeave'
    }else if(this.rules?.readyToLeaveBate){
      this.triggerFactor = 'readyToLeaveBate'
    }else if(this.rules?.addPurchaseDownShow){
      this.triggerFactor = 'addPurchaseDownShow'
    }else if(this.rules?.couponLinkJump){
      this.triggerFactor = 'couponLinkJump'
    }else if(this.rules?.discardBillLeave){
      this.triggerFactor = 'discardBillLeave'
    }else if(this.rules?.loadingPageSlideShow){
      this.triggerFactor = 'loadingPageSlideShow'
    } else if (this.rules?.addPurchaseJumpPageShow) {
      this.triggerFactor = 'addPurchaseJumpPageShow';
    } else {
      this.triggerFactor = ''
    }
  }

  changeSubscribeRulesData(val: string){
    this.rules.loadingCountDownShow = false
    this.rules.loadingPageSlideShow = false
    this.rules.readyToLeave = false
    this.rules.readyToLeaveBate = false
    this.rules.couponLinkJump = false
    this.rules.addPurchaseDownShow = false
    this.rules.addPurchaseJumpPageShow = false
    this.rules.discardBillLeave = false
    this.rules[val] = true
    this.$emit('changeRulesData',this.rules)
  }

  async getCountryList() {
    try {
      const result = await getCountryList({});
      this.countryList = result.data.data;
    } catch (e: any) {
      if (e?.handled) {
        return;
      }
      this.$message.warning(this.$tx('form.rules.err.countryFail', '获取国家列表失败!'));
    }
  }

  copyCode(){
    const code = (document.getElementById('dispaly-rules-form-code') as HTMLTextAreaElement).value;
    navigator.clipboard.writeText(code);
    this.$message.success(this.$tx('common.success.copy', '复制成功'));
  }

  mounted() {
    this.setInitData();
  }
  setInitData() {
    if (
      this.targeting?.urls?.length > 0 ||
      this.targeting?.urlParts?.length > 0 ||
      this.targeting?.excludeUrls?.length > 0 ||
      this.targeting?.excludeUrlParts?.length > 0
    ) {
      this.showTargetUrl = true;
    }
    if (this.targeting.pages?.includes('1')) {
      this.selectList['1'] = true;
    }
    if (this.targeting.pages?.includes('2')) {
      this.selectList['2'] = true;
    }
    if (this.targeting.pages?.includes('3')) {
      this.selectList['3'] = true;
    }
    if (this.targeting.excludePages?.includes('4')) {
      this.selectList['4'] = true;
    }
    if (this.targeting.excludePages?.includes('5')) {
      this.selectList['5'] = true;
    }
    this.showPageCheckout = false;
    this.$nextTick(() => {
      this.showPageCheckout = true;
      this.$forceUpdate();
    });
  }

  openTargetingPreview() {
    this.targetingPreviewHostnameInput = this.targetingPreviewHostname;
    this.targetingPreviewVisible = true;
    this.targetingPreviewResult = null;
  }

  resetTargetingPreviewHostname() {
    this.targetingPreviewHostnameInput = this.targetingPreviewHostname;
  }

  validateTargetingPreviewUrl() {
    if (!this.targetingPreviewInputUrl.trim()) {
      this.$message.warning(this.$tx('form.rules.preview.urlPh', '请输入要验证的页面 URL'));
      return;
    }
    // B 端仅做规则预检，不改写当前 targeting 配置和 C 端展示逻辑。
    this.targetingPreviewResult = previewTargetingUrl(
      this.targeting as any,
      this.targetingPreviewInputUrl,
      this.targetingPreviewHost
    );
  }

  getTargetingPreviewTagClass(status: string) {
    if (status === '展示') return 'cs-tag-success';
    if (status === '部分展示') return 'cs-tag-warning';
    return 'cs-tag-danger';
  }

  getTargetingPreviewTextClass(status: string) {
    if (status === '展示') return 'target-preview-visible-text';
    if (status === '部分展示') return 'target-preview-partial-text';
    return 'target-preview-hidden-text';
  }

  targetingPreviewStatusLabel(status: string) {
    if (status === '展示') return this.$tx('form.rules.preview.show', '展示');
    if (status === '部分展示') return this.$tx('form.rules.preview.partial', '部分展示');
    return this.$tx('form.rules.preview.hide', '不展示');
  }

  changeIncludeArea(val: any){
    if (!val) {
      this.rules.includeAreaList = [];
    }
    window?.gtagClick('form_edit_country_display', '弹窗_编辑订阅工具_国家显示设置');
  }

  changeExcludeArea(val: any){
    if (!val) {
      this.rules.excludeAreaList = [];
    }
    window?.gtagClick('form_edit_country_display', '弹窗_编辑订阅工具_国家显示设置');
  }

  displayFrequencyInit(){
    // 保持与 master 一致的边界判断（> 而非 >=），避免 3600s(60m)/60s(1m) 被改显示为 1h/1m，
    // 从而保证分钟/秒单位的线上现状不变。168h 需求只需小时分支能到达 168 即可（604800 > 3600）。
    // 只决定单位（getter 会据此反推显示数字），不再写回 displayFrequency，避免与 setter 重复/漂移。
    const seconds = (this.rules && this.rules.displayFrequency) || 0;
    const unit: FrequencyUnit =
      seconds > HOUR_IN_SECONDS ? 'h' :
      seconds > UNIT_SECONDS.m ? 'm' : 's';
    this.displayFrequencyValue = unit;
    this.prevFrequencyUnit = unit;
  }

  // 检查是否至少选择了一个触发条件
  hasAnyTriggerCondition(): boolean {
    const triggerFields = [
      'loadingCountDownShow',
      'loadingPageSlideShow',
      'readyToLeave',
      'readyToLeaveBate',
      'couponLinkJump',
      'addPurchaseDownShow',
      'addPurchaseJumpPageShow',
      'discardBillLeave'
    ];
    return triggerFields.some(field => this.rules?.[field]);
  }

  changeUrls({url , urlParts}:any){
    this.targeting.urls = url
    this.targeting.urlParts = urlParts
    this.changeTargetingData()
    window?.gtagClick('form_edit_setUrl','弹窗_编辑订阅工具_设置页面圈选')
  }

  changeExcludeUrls({url , urlParts}:any){
    this.targeting.excludeUrls = url
    this.targeting.excludeUrlParts = urlParts
    this.changeTargetingData()
    window?.gtagClick('form_edit_setUrl','弹窗_编辑订阅工具_设置页面圈选')
  }

  changeTargetingData(){
    this.$emit('changeTargetingData',this.targeting)
  }

  save(){
    if (this.valid()) {
      this.$emit('save')
    }
    window?.gtagClick('form_tool_enable','弹窗_启用订阅工具')
  }

  valid() {
    return this.targetingValid() && this.translateValid()
  }

  saveDraft(){
    if (this.isAbtest) {
      if (!this.isEditAbTest) {
        return;
      }
    }
    if (this.valid()) {
      this.$emit('saveDraft')
    }
    window?.gtagClick('form_tool_save','弹窗_保存订阅工具')
  }

  nextStep() {
    if (this.valid()) {
      this.$emit('nextStep')
    }
  }

  backStep() {
    if (this.valid()) {
      this.$emit('backStep')
    }
  }

  cancel(){
    if (this.valid()) {
      this.$emit('cancel')
    }
  }

  translateValid() {
    if (this.rules.includeArea && this.rules.includeAreaList.length <= 0) {
      this.$message.warning(this.$tx('form.rules.err.includeEmpty', '向特定位置的用户展示为空，请选择'));
      return false
    }

    if (this.rules.excludeArea && this.rules.excludeAreaList.length <= 0) {
      this.$message.warning(this.$tx('form.rules.err.excludeEmpty', '不向特定位置的用户展示为空，请选择'));
      return false
    }

    return true;
  }

  //校验
  targetingValid(){
    //在特定页面展示为空
    if (this.$refs.inPages && !this.$refs.inPages.valid() ) {
      return false
    }
    //不在特定页面展示
    if (this.$refs.noInPages && !this.$refs.noInPages.valid() ) {
      return false
    }

    //选择用户群校验
    if(!this.rules.subscribedSubscriber && !this.rules.unsubscribedSubscriber && !(this.triggerEventType === TriggerEventType.NEW_USER_SUBSCRIBE && this.rules.deepVisitLowIntentSubscriber)){
      this.$message.warning(this.$tx('form.rules.err.needGroup', '请选择用户群'))
      return false
    }

    //两个筛选条件不能存在相同的URL
    let includeUrls = this.targeting?.urls?.concat(this.targeting?.urlParts)
    let excludeUrls = this.targeting?.excludeUrls?.concat(this.targeting?.excludeUrlParts)
    let count = 0
    includeUrls?.forEach((includeItem) => {
      excludeUrls?.forEach((excludeItem) => {
        if(includeItem.url == excludeItem.url){
          count++
        }
      });
    });
    if(count != 0){
      this.$message.warning(this.$tx('form.rules.err.urlDup', 'URL不能相同'))
      return false
    }

    if (this.triggerEventType === TriggerEventType.NEW_USER_SUBSCRIBE) {
      if (!this.hasAnyTriggerCondition()) {
        this.$message.warning(this.$tx('form.rules.err.needTrigger', '请至少选择一个触发条件'))
        return false
      }
    } else if (!this.triggerFactor && this.triggerEventType !== TriggerEventType.BACK_IN_STOCK && this.triggerEventType !== TriggerEventType.EMBEDDED_FORM && this.triggerEventType !== TriggerEventType.CUSTOM_TRIGGER) {
      this.$message.warning(this.$tx('form.rules.err.triggerEmpty', '触发条件不能为空'))
      return false
    }
    return true
  }

  //设置倒计时步长
  loadingCountDownOptionsFun(){
    let arr  = []
    for (let i = 0; i < 20; i++) {
      arr.push(i)
    }
    for (let i = 20; i <= 120; i=i+5) {
      arr.push(i)
    }
    this.loadingCountDownOptions = arr
  }

  onFrequencyUnitChange(newUnit: FrequencyUnit){
    // 单位切换：保留旧单位下的显示数字，按新单位通过 setter 统一钳制并写回秒值
    // （el-select 的 v-model 会先把 displayFrequencyValue 更新为新单位，故用 prevFrequencyUnit 取旧单位显示数字）
    if (!this.rules) { this.prevFrequencyUnit = newUnit; return; }
    const seconds = this.rules.displayFrequency || 0;
    // 未设置过（0）时只切单位，不触发 setter 把 0 钳成 1
    if (!seconds) { this.prevFrequencyUnit = newUnit; return; }
    const oldDisplayValue = seconds / UNIT_SECONDS[this.prevFrequencyUnit];
    this.prevFrequencyUnit = newUnit;
    // 此时 displayFrequencyValue 已是新单位，setter 会按新单位 max 钳制并换算
    this.displayFrequency = oldDisplayValue;
  }

  changeRulesData(){
    this.$emit('changeRulesData',this.rules)
  }
  changeRulesDataGa(){
    this.$emit('changeRulesData',this.rules)
    window?.gtagClick('form_edit_setCountdown','弹窗_编辑订阅工具_设置倒计时器')
  }

  changePixelValue(rules){
    if(isNaN(rules.loadingPageSlidePixel)){
      rules.loadingPageSlidePixel = 400
    }
  }

  changeSingleSubscribers(val){
    this.rules.subscribedSubscriber = false
    this.rules.unsubscribedSubscriber = false
    this.rules[val] = true
    this.$emit('changeRulesData',this.rules)
  }
  changeMultiSubscribers(){
    this.$emit('changeRulesData',this.rules)
    if(this.rules.clickBackgroundCloseOption){
      window?.gtagClick('form_edit_toggleClickClose','弹窗_编辑订阅工具_设置空白处点击关闭')
    }
  }


  @Watch('measureValue1')
  changeMeasureValue1(val:number){
    this.rules.measureValue = val + '-'+ this.measureValue2
    this.$emit('changeRulesData',this.rules)
  }

  @Watch('measureValue2')
  changeMeasureValue2(val:number){
    this.rules.measureValue = this.measureValue1 + '-'+ val
    this.$emit('changeRulesData',this.rules)
  }

  @Watch('rulesData')
  changerulesData(val:any){
    this.rules = val
    if (this.rules?.popupLayoutMode === 'fullscreen') {
      this.rules.clickBackgroundCloseOption = false;
    }
    this.displayFrequencyInit()
    this.triggerRules()
    this.initExitIntentTriggerFactor()
  }

  @Watch('delayRecommendation')
  delayRecommendationWatch(value: any, previous: any) {
    if (value && !previous) {
      this.delayRecommendationDismissed = false;
      this.delayImpressionReported = false;
      if (this.delayRecommendationTriggered) {
        this.$nextTick(() => this.reportRuleImpression('delay'));
      }
    }
    if (!value) {
      this.delayImpressionReported = false;
      this.delayRecommendationTriggered = false;
    }
  }

  @Watch('scrollRecommendation')
  scrollRecommendationWatch(value: any, previous: any) {
    if (value && !previous) {
      this.scrollRecommendationDismissed = false;
      this.scrollImpressionReported = false;
      if (this.scrollRecommendationTriggered) {
        this.$nextTick(() => this.reportRuleImpression('scroll'));
      }
    }
    if (!value) {
      this.scrollImpressionReported = false;
      this.scrollRecommendationTriggered = false;
    }
  }

  @Watch('targetingData')
  changetargetingData(val:any){
    this.targeting = val
    if (val?.urls?.length > 0 || val?.urlParts?.length > 0 || val?.excludeUrls?.length > 0 || val?.excludeUrlParts?.length > 0) {
      this.showTargetUrl = true;
    }
    this.setInitData();
  }


  showTargetUrl = false;
  showTarget() {
    this.showTargetUrl = !this.showTargetUrl;
  }

  selectList = {
    "1":false,
    "2":false,
    "3":false,
    "4":false,
    "5":false,
  }

  targetIsChecked(pageId:any) {
    return this.targeting.pages?.includes(pageId);
  }
  targetChecked(checked:boolean, pageId:any) {
    this.targeting.pages = this.targeting.pages?.filter((oldId:any) => pageId != oldId) || [];
    if (checked) {
      this.targeting.pages.push(pageId);
    }
    this.changeTargetingData()
    window?.gtagClick('form_edit_setUrl','弹窗_编辑订阅工具_设置页面圈选')
  }
  targetExcludeIsChecked(pageId:any) {
    return this.targeting.excludePages?.includes(pageId);
  }
  targetExcludeChecked(checked:boolean, pageId:any) {
    this.targeting.excludePages = this.targeting.excludePages?.filter((oldId:any) => pageId != oldId) || [];
    if (checked) {
      this.targeting.excludePages.push(pageId);
    }
    this.changeTargetingData()
    window?.gtagClick('form_edit_setUrl','弹窗_编辑订阅工具_设置页面圈选')
  }
}
